<div
  *ngIf="invite.sender && invite.recipient && invite.target"
  class="card-comment"
  style="line-height: 100%"
>
  <div class="card-block-small">
    <img
      *ngIf="invite.sender.image"
      class="invite-user-img"
      [src]="invite.sender.image"
      alt="sender-image"
    />
    <img
      *ngIf="!invite.sender.image"
      class="invite-user-img"
      [src]="defaultUserImg"
      alt="sender-image"
    />
    <div class="comment-desc">
      <div class="text-left">
        <h6 class="text-secondary">
          <strong>
            Invite to {{ invite.targetModel }} From:
            {{ invite.sender.username | slice: 0:25 }}
          </strong>
        </h6>

        <div *ngIf="invite.targetModel === 'Discussion'">
          <a [routerLink]="['/discussion', invite.target.slug]">
            <p
              style="margin: 0"
              class="text-muted"
              [innerHTML]="invite.target.title | slice: 0:75"
            ></p>
          </a>
        </div>

        <div *ngIf="invite.targetModel === 'Community'">
          <a [routerLink]="['/community', invite.target.name]">
            <p
              style="margin: 0"
              class="text-muted"
              [innerHTML]="invite.target.name | slice: 0:75"
            ></p>
          </a>
        </div>
      </div>

      <div class="text-left">
        <span class="text-muted">
          <em> received, {{ invite.createdAt | date: "longDate":"UTC" }} </em>
        </span>
      </div>
    </div>
  </div>
  <hr />
</div>
